import React from 'react';
import PropTypes from 'prop-types';
import SocialIcons from '@components/SocialIcons';
import FlapBoard from '@components/FlapBoard';
import ClockBoard from '@components/ClockBoard';
import { toElement as scrollToElement } from '@utils/scroll';

import './style.scss';

const HERO_ROWS = [
  {
    text:   'DANNY NGUYEN',
    colors: ['indigo','indigo','indigo','indigo','indigo','black','purple','purple','purple','purple','purple','purple'],
    icons:  [
      '','','','','','','','','','','','', // cols 0–11 (text chars)
      '',                                   // col 12
      'fab fa-github',                      // col 13
      '',                                   // col 14
      'fab fa-linkedin',                    // col 15
      '',                                   // col 16
      'fab fa-twitter',                     // col 17
      '',
      'fab fa-apple',
      '',
      'fab fa-google',
      '',
      'fab fa-spotify',
      '',
      'fab fa-stack-overflow',
    ],
  },
  {
    text:   'SOFTWARE ENGINEER',
    colors: ['cyan','cyan','cyan','cyan','cyan','cyan','cyan','cyan','black','teal','teal','teal','teal','teal','teal','teal','teal'],
    icons:  [
      '','','','','','','','','','','','','','','','','', // cols 0–16 (text chars)
      '',                                                   // col 17
      'fab fa-react',                                       // col 18
      '',                                                   // col 19
      'fab fa-python',                                      // col 20
      '',
      'fab fa-js',
      '',
      'fab fa-node',
      '',
      'fas fa-code',
    ],
  },
  {
    text:   'REACT · PYTHON · TYPESCRIPT',
    colors: ['blue','blue','blue','blue','blue','black','pink','black','pink','pink','pink','pink','pink','pink','black','purple','black','purple','purple','purple','purple','purple','purple','purple','purple','purple','purple'],
  },
];

const HERO_ROWS_MOBILE = [
  {
    text:   'DANNY NGUYEN',
    colors: ['indigo','indigo','indigo','indigo','indigo','black','purple','purple','purple','purple','purple','purple'],
  },
  {
    text:   'SOFTWARE',
    colors: ['cyan','cyan','cyan','cyan','cyan','cyan','cyan','cyan'],
  },
  {
    text:   'ENGINEER',
    colors: ['teal','teal','teal','teal','teal','teal','teal','teal'],
  },
  {
    text:   'REACT PYTHON',
    colors: ['blue','blue','blue','blue','blue','black','pink','pink','pink','pink','pink','pink'],
  },
  {
    text:   'TYPESCRIPT',
    colors: ['purple','purple','purple','purple','purple','purple','purple','purple','purple','purple'],
  },
];

const LandingPage = (props, context) => {
  const { theme: { colorPrimary } } = context;

  return (
    <div className="landing-page">
      <main>
        <div className="intro-wrapper">
          <div className="intro-left">
            <h1 className="visually-hidden">Danny Nguyen, Software Engineer</h1>
            <span className="intro-eyebrow">Software Engineer</span>
            <p className="intro-lead">
              I build{' '}
              <span className="intro-lead__accent" style={{ color: colorPrimary }}>
                polished interfaces
              </span>{' '}
              for the web.
            </p>
            <p className="intro-sub">CVS Health · Based in Colorado</p>
            <div className="intro-divider" />
            <div className="intro-buttons">
              <button
                className="btn-neon"
                style={{ color: colorPrimary, borderColor: colorPrimary }}
                onClick={() => scrollToElement(document.getElementById('projects'))}
              >
                View My Work
              </button>
              <button
                className="btn-ghost"
                onClick={() => scrollToElement(document.getElementById('contact'))}
              >
                Contact Me
              </button>
            </div>
            <SocialIcons />
          </div>
          <div className="intro-right" aria-hidden="true">
            <div className="board-housing">
              <div className="hero-board--desktop">
                <FlapBoard autoPlay={true} loop={true} rows={HERO_ROWS} />
                <div className="board-divider" />
                <ClockBoard cols={27} />
              </div>
              <div className="hero-board--mobile">
                <FlapBoard autoPlay={true} loop={true} rows={HERO_ROWS_MOBILE} />
                <div className="board-divider" />
                <ClockBoard cols={12} />
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

LandingPage.contextTypes = {
  theme: PropTypes.any
};

export default LandingPage;



// WEBPACK FOOTER //
// ./src/pages/LandingPage/LandingPage.js